import React from 'react'
import './AthleteSocialMedia.css'
import '../layout/Spinner.css'

const AthleteSocialMedia = (props) => {

        const athleteSocialMedia = props.athleteSocialMedia

        var socialMediaStuff = null

        if (athleteSocialMedia) {

            if (athleteSocialMedia.twitter && athleteSocialMedia.twitter !== 'None') {

                socialMediaStuff = <a href={athleteSocialMedia.twitter} target="_blank" rel="noopener noreferrer" key='twitter'>
                                        <img src={require('../../images/twitter.svg').default} alt="Twitter"/>
                                    </a>
            }


            if (athleteSocialMedia.facebook && athleteSocialMedia.facebook !== 'None') {

                socialMediaStuff = [
                    socialMediaStuff,
                    <a href={athleteSocialMedia.facebook} target="_blank" rel="noopener noreferrer" key='facebook'>
                        <img src={require('../../images/facebook.svg').default} alt="Facebook"/>
                    </a>
                ]
            }

            if (athleteSocialMedia.instagram && athleteSocialMedia.instagram !== 'None') {

                socialMediaStuff = [
                    socialMediaStuff,
                    <a href={athleteSocialMedia.instagram} target="_blank" rel="noopener noreferrer" key='instagram'>
                        <img src={require('../../images/instagram.svg').default} alt="Instagram"/>
                    </a>
                ]
            }

            if (athleteSocialMedia.youTube && athleteSocialMedia.youTube !== 'None') {

                socialMediaStuff = [
                    socialMediaStuff,
                    <a href={athleteSocialMedia.youTube} target="_blank" rel="noopener noreferrer" key='youTube'>
                        <img src={require('../../images/playButton.svg').default} alt="Play Button"/>
                    </a>
                ]
            }

            if (athleteSocialMedia.hudl && athleteSocialMedia.hudl !== 'None') {

                socialMediaStuff = [
                    socialMediaStuff,
                        <a href={athleteSocialMedia.hudl} target="_blank" rel="noopener noreferrer" key='hudl'>
                            <img src={require('../../images/hudl.svg').default} alt="Hudl Logo"/>
                        </a>
                ]
            }
        }

        const displaySocialMedia = (
            <div className="AthleteSocialMediaGroupContainer">
                {socialMediaStuff}
            </div>
        )

        return displaySocialMedia
}

export default AthleteSocialMedia